/* Mateo Kadriu, official site. Small, no libraries.
   Built to stay smooth: everything that moves is a GPU animation (transform or opacity), and the script only does
   work when something actually changes, never on every frame. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  root.classList.add('mk-ready');
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = w.matchMedia('(min-width: 900px)');
  var homeView = $('#homeView'), storyView = $('#storyView'), curtainEl = $('#mkCurtain');
  var isHome = !!homeView;
  var raf = w.requestAnimationFrame ? function (f) { w.requestAnimationFrame(f); } : function (f) { setTimeout(f, 16); };

  /* The MK curtain: covers the page, runs fn while it is black, then lifts */
  function curtain(fn) {
    if (!curtainEl || reduce) { fn(); return; }
    curtainEl.classList.remove('is-on', 'is-leaving'); void curtainEl.offsetWidth; curtainEl.classList.add('is-on');
    setTimeout(function () { fn(); setTimeout(function () { curtainEl.classList.remove('is-on'); }, 80); }, 460);
  }

  /* His photo is cropped around him (crop and scale only, never altered). CSS does it from the first paint;
     this is only for old browsers without container units. */
  var PW = 1200, PH = 1921, cssCrop = !!(w.CSS && CSS.supports && CSS.supports('width', '1cqw'));
  function crop(fig, fx, fy, span) {
    var img = $('img', fig), W = fig.clientWidth, H = fig.clientHeight; if (!img || !W || !H) return null;
    var s = Math.max(H / span, W / PW, H / PH), iw = PW * s, ih = PH * s;
    var left = Math.min(0, Math.max(W - iw, W / 2 - fx * s)), top = Math.min(0, Math.max(H - ih, H / 2 - fy * s));
    img.style.width = iw + 'px'; img.style.height = ih + 'px'; img.style.left = left + 'px'; img.style.top = top + 'px';
    return { s: s, left: left, top: top };
  }
  function layout() {
    if (cssCrop) return;
    var hp = $('#heroPhoto');
    if (hp) { if (desk.matches) crop(hp, 612, 760, 1400); else crop(hp, 612, 640, 1150); }
    $$('.sv__photo').forEach(function (sp) { if (!sp.offsetWidth) return; if (desk.matches) crop(sp, 612, 1010, 1921); else crop(sp, 612, 700, 1100); });
  }
  layout();
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(layout);
  var rt; w.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(); onScroll(); }, 80); });

  /* Moving around the home page: a menu button brings its section to the top, already shown */
  function jump(id, smooth) {
    var t = d.getElementById(id); if (!t) return;
    $$('[data-rv]', t).forEach(function (el) { el.classList.add('is-in'); });
    var y = id === 'home' ? 0 : t.getBoundingClientRect().top + w.pageYOffset - 70;
    w.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduce ? 'smooth' : 'auto' });
  }
  function hashJump() {
    if (!isHome) return;
    var id = (location.hash || '').slice(1);
    if (id && /^(story|toptech|contact)$/.test(id)) { hold(id); jump(id, false); }
  }

  /* Opening: the MK intro and the hero animations are timed by CSS from the first paint, so they never wait for this
     script or for anything else the page loads. Here we only tidy up once they are done. */
  var intro = $('#mkIntro'), heroIn = $('.hero__in');
  function dropIntro() { if (intro && intro.parentNode) intro.parentNode.removeChild(intro); intro = null; }
  if (intro) { intro.addEventListener('animationend', function (e) { if (e.animationName === 'mkgone') dropIntro(); }); setTimeout(dropIntro, 3000); }
  if (heroIn) heroIn.addEventListener('animationend', function (e) { if (e.target === heroIn) heroIn.style.willChange = 'auto'; });
  w.addEventListener('pageshow', function (e) { if (e.persisted && curtainEl) curtainEl.classList.remove('is-on', 'is-leaving'); });

  /* Things come in as you scroll */
  var rvs = $$('[data-rv]');
  if ('IntersectionObserver' in w && !reduce) {
    var rio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } }); }, { rootMargin: '0px 0px -4% 0px' });
    rvs.forEach(function (el) { rio.observe(el); });
  } else rvs.forEach(function (el) { el.classList.add('is-in'); });

  /* The story line fills in word by word as you scroll past it (only touched when the count changes) */
  var state = $('[data-words]'), words = [], lit = -1;
  if (state) {
    state.innerHTML = state.textContent.trim().split(/\s+/).map(function (x) { return '<span class="w">' + x.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>'; }).join(' ');
    words = $$('.w', state);
  }
  function paintWords() {
    if (!words.length || (homeView && homeView.hidden)) return;
    var n = words.length;
    if (!reduce) { var r = state.getBoundingClientRect(), vh = w.innerHeight; n = Math.round(Math.max(0, Math.min(1, (vh * 0.9 - r.top) / (r.height + vh * 0.3))) * words.length); }
    if (n === lit) return; lit = n;
    for (var i = 0; i < words.length; i++) words[i].classList.toggle('on', i < n);
  }

  /* Highlight where you are in the menu (home page). It is worked out from where the sections sit, so a fast scroll
     can never skip one, and after a tap the tapped item stays lit until the visitor scrolls by hand. */
  var links = $$('.pill a[data-go], .pill a[data-spy]'), held = null, marked = null;
  function mark(id) { if (id === marked) return; marked = id; links.forEach(function (l) { l.classList.toggle('is-on', (l.getAttribute('data-spy') || l.getAttribute('data-go')) === id && id !== 'home'); }); }
  function hold(id) { held = id; mark(id); }
  function letGo() { held = null; }
  function spy() {
    if (!isHome || root.classList.contains('is-story')) return;
    if (held) { mark(held); return; }
    var line = 70 + Math.min(w.innerHeight * 0.3, 220), cur = 'home';
    ['story', 'toptech', 'blogs', 'contact'].forEach(function (id) { var s = d.getElementById(id); if (s && s.getBoundingClientRect().top <= line) cur = id; });
    if (w.pageYOffset > 0 && w.innerHeight + w.pageYOffset >= root.scrollHeight - 4) cur = 'contact';
    mark(cur);
  }
  if (isHome) {
    w.addEventListener('wheel', letGo, { passive: true });
    w.addEventListener('touchmove', letGo, { passive: true });
    w.addEventListener('keydown', function (e) { if (/^(ArrowUp|ArrowDown|PageUp|PageDown|Home|End| |Spacebar)$/.test(e.key)) letGo(); });
  }

  /* One light scroll handler for everything above */
  function onScroll() { paintWords(); spy(); }
  var sq = false;
  w.addEventListener('scroll', function () { if (sq) return; sq = true; raf(function () { sq = false; onScroll(); }); }, { passive: true });

  /* The waveform: fixed bar heights, moved only by CSS animations on the GPU. Shared with the theme editor redraw. */
  function waveBars(n) {
    var seed = 7, html = '', per = Math.ceil(n / 8), i;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    for (i = 0; i < n; i++) {
      var env = 0.45 + 0.55 * Math.abs(Math.sin(i * 0.21 + 0.6)) * (0.6 + 0.4 * Math.sin(i * 0.07));
      var h = Math.max(0.18, Math.min(1, env * (0.55 + rnd() * 0.45)));
      if (i % per === 0) html += (i ? '</span>' : '') + '<span class="wg" style="--g:' + (i / per) + '">';
      html += '<i style="height:' + (h * 100).toFixed(1) + '%;--p:' + (-(rnd() * 0.8)).toFixed(2) + 's;--pd:' + (0.36 + rnd() * 0.28).toFixed(2) + 's"></i>';
    }
    return html + '</span>';
  }

  /* Top Tech: the newest episode (read from the show's feed, so it updates itself) and Play right here */
  (function () {
    var card = $('#player'); if (!card) return;
    var wave = $('#wave'), N = desk.matches ? 64 : 40;
    wave.innerHTML = waveBars(N);
    var bars = $$('i', wave);

    /* One object holds the episode on show (date, length, audio, link), so the date you see is always the episode that plays */
    var EP = { date: card.getAttribute('data-date'), secs: +card.getAttribute('data-secs') || 0, audio: card.getAttribute('data-audio'), url: card.getAttribute('data-url') };
    var meta = $('#epMeta'), cur = $('#epCur'), dur = $('#epDur'), btn = $('#epPlay'), alt = $('#epAlt'), audio = $('#epAudio');
    function mmss(t) { t = Math.max(0, Math.round(t || 0)); return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2); }
    function render() {
      var when = new Date(EP.date), now = new Date();
      if (isNaN(when)) { meta.innerHTML = '<b>Latest episode</b>'; return; }
      /* the day it came out in Albania, so everyone sees the same date as the show */
      var opts = { month: 'short', day: 'numeric', timeZone: 'Europe/Tirane' }, day;
      if (when.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
      try { day = when.toLocaleDateString('en-US', opts); } catch (x) { delete opts.timeZone; day = when.toLocaleDateString('en-US', opts); }
      var fresh = now - when < 8 * 864e5;
      meta.innerHTML = '<b>' + (fresh ? 'New episode' : 'Latest episode') + '</b> · ' + day.replace(/ /g, ' ') + (EP.secs ? ' · ' + Math.max(1, Math.round(EP.secs / 60)) + ' min' : '');
      dur.textContent = mmss(EP.secs);
      if (EP.url) alt.href = EP.url;
    }
    render();

    /* Find the newest episode in two places at once (the show's own feed and Apple Podcasts) and keep the newest.
       It starts right after the page loads, so it is ready long before anyone reaches Play. */
    var feed = card.getAttribute('data-feed'), apple = (card.getAttribute('data-apple') || '').match(/id(\d+)/), looked = false, ready = false, waiting = null;
    function consider(ep) {
      if (!ep || !ep.audio || !ep.date || isNaN(ep.date)) return;
      if (audio.getAttribute('src') && !waiting) return;
      var now = new Date(EP.date);
      if (!isNaN(now) && ep.date <= now) return;
      EP = { date: ep.date.toISOString(), secs: ep.secs || 0, audio: ep.audio, url: ep.url || EP.url };
      render();
    }
    function done() { if (ready) return; ready = true; if (waiting) { var f = waiting; waiting = null; f(); } }
    function lookup() {
      if (looked) return; looked = true;
      var left = 0;
      function finish() { left--; if (left <= 0) done(); }
      if (feed && w.fetch) {
        left++;
        fetch('https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(feed)).then(function (r) { return r.json(); }).then(function (dd) {
          var it = dd && dd.status === 'ok' && dd.items && dd.items[0];
          if (it && it.pubDate) consider({ date: new Date(it.pubDate.replace(' ', 'T') + 'Z'), secs: +(it.enclosure && it.enclosure.duration) || 0, audio: it.enclosure && it.enclosure.link, url: it.link });
        }).catch(function () {}).then(finish);
      }
      if (apple) {
        left++;
        var cb = 'mkEp' + Date.now(), s = d.createElement('script'), over = false;
        var stop = function () { if (over) return; over = true; w[cb] = function () {}; if (s.parentNode) s.parentNode.removeChild(s); finish(); };
        w[cb] = function (res) {
          var list = ((res && res.results) || []).filter(function (r) { return r.kind === 'podcast-episode' && r.episodeUrl && r.releaseDate; });
          list.sort(function (a, b) { return new Date(b.releaseDate) - new Date(a.releaseDate); });
          if (list[0]) consider({ date: new Date(list[0].releaseDate), secs: Math.round((list[0].trackTimeMillis || 0) / 1000), audio: list[0].episodeUrl, url: list[0].trackViewUrl });
          stop();
        };
        s.async = true; s.onerror = stop; setTimeout(stop, 5000);
        s.src = 'https://itunes.apple.com/lookup?id=' + apple[1] + '&entity=podcastEpisode&limit=5&callback=' + cb;
        d.head.appendChild(s);
      }
      if (!left) done();
      setTimeout(done, 5000);
    }
    if (d.readyState === 'complete') setTimeout(lookup, 600); else w.addEventListener('load', function () { setTimeout(lookup, 600); });
    if ('IntersectionObserver' in w) { var fo = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { lookup(); fo.disconnect(); } }, { rootMargin: '900px 0px' }); fo.observe(card); }
    else lookup();

    /* the waveform only moves while the player is on screen: it breathes while idle and dances while playing */
    if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { card.classList.toggle('is-vis', es[0].isIntersecting); }).observe(card);
    else card.classList.add('is-vis');

    /* the mini player follows you once the episode has started and the big player is off screen */
    var playing = false, mini = $('#mini'), miniTime = $('#miniTime'), miniBtn = $('#miniBtn'), inView = true;
    function miniShow() { if (!mini) return; var on = !!audio.getAttribute('src') && !audio.ended && (playing || audio.currentTime > 0) && !inView; mini.classList.toggle('is-on', on); mini.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { inView = es[0].isIntersecting && !homeView.hidden; miniShow(); }, { threshold: 0.15 }).observe(card);
    d.addEventListener('mk:view', function () { if (homeView.hidden) inView = false; miniShow(); });
    if (miniBtn) miniBtn.addEventListener('click', function () { btn.click(); });
    var miniGo = $('#miniGo');
    if (miniGo) miniGo.addEventListener('click', function () { if (root.classList.contains('is-story')) { closeStory('toptech'); return; } hold('toptech'); jump('toptech', true); });
    var shown = -1;
    function progress() {
      var total = audio.duration || EP.secs, f = total ? audio.currentTime / total : 0, k = Math.round(f * N);
      if (k !== shown) { shown = k; for (var j = 0; j < N; j++) bars[j].classList.toggle('on', j < k); }
      cur.textContent = mmss(audio.currentTime);
      if (audio.duration) dur.textContent = mmss(audio.duration);
      if (miniTime) miniTime.textContent = mmss(audio.currentTime) + ' / ' + mmss(audio.duration || EP.secs);
    }
    function setPlaying(on) {
      playing = on; card.classList.toggle('is-playing', on); btn.setAttribute('aria-label', on ? 'Pause' : 'Play the latest episode');
      if (mini) { mini.classList.toggle('is-playing', on); miniBtn.setAttribute('aria-label', on ? 'Pause' : 'Play'); }
      miniShow();
    }
    function fallback() { setPlaying(false); card.classList.add('is-fallback'); }
    function startEp() {
      card.classList.remove('is-loading');
      if (!EP.audio) { fallback(); return; }
      if (audio.getAttribute('src') !== EP.audio) audio.src = EP.audio;
      var p; try { p = audio.play(); } catch (e) { fallback(); return; }
      if (p && p.then) p.then(function () { setPlaying(true); }, function (er) { if (!er || er.name !== 'AbortError') fallback(); }); else setPlaying(true);
    }
    btn.addEventListener('click', function () {
      card.classList.add('is-started');
      if (waiting) return;
      if (audio.getAttribute('src')) { if (audio.paused) startEp(); else { audio.pause(); setPlaying(false); } return; }
      if (ready) { startEp(); return; }
      /* the newest episode is still being checked: unlock the player inside this tap, then play the newest as soon as it is known */
      card.classList.add('is-loading');
      try { audio.src = EP.audio; var q = audio.play(); if (q && q.catch) q.catch(function () {}); audio.pause(); } catch (e) {}
      waiting = startEp;
      lookup();
      setTimeout(done, 2500);
    });
    wave.addEventListener('click', function (e) {
      if (!audio.getAttribute('src') || !(audio.duration > 0)) return;
      var r = wave.getBoundingClientRect(); audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration; progress();
    });
    audio.addEventListener('timeupdate', progress);
    audio.addEventListener('ended', function () { setPlaying(false); });
    audio.addEventListener('error', fallback);
  })();

  /* The full story opens on the home page with the MK curtain; Back always returns to the top */
  function openStory() {
    if (!storyView) return;
    curtain(function () { homeView.hidden = true; storyView.hidden = false; root.classList.add('is-story'); w.scrollTo(0, 0); layout(); mark('story'); d.dispatchEvent(new Event('mk:view')); });
  }
  function closeStory(id) {
    if (!storyView) return;
    curtain(function () {
      storyView.hidden = true; homeView.hidden = false; root.classList.remove('is-story'); layout();
      if (id && id !== 'home') { hold(id); jump(id, false); } else { hold('home'); w.scrollTo(0, 0); }
      lit = -1; onScroll(); d.dispatchEvent(new Event('mk:view'));
    });
  }
  $$('[data-open-story]').forEach(function (b) { b.addEventListener('click', openStory); });
  $$('[data-close-story]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeStory('home'); }); });

  /* Links: menu buttons on the home page glide to their section; links to another page get a quick MK curtain */
  function isPageLink(a) {
    if (!a.href || a.target === '_blank' || a.hasAttribute('download') || a.origin !== location.origin) return false;
    return !/\.(pdf|jpe?g|png|webp|gif|zip|mp3)$/i.test(a.pathname);
  }
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a') : null; if (!a) return;
    var go = a.getAttribute('data-go');
    if (go && isHome) {
      e.preventDefault();
      if (root.classList.contains('is-story')) { closeStory(go); return; }
      hold(go); jump(go, true);
      return;
    }
    if (!isPageLink(a)) return;
    if (a.pathname === location.pathname && a.search === location.search) {
      if (a.hash) return;
      e.preventDefault(); w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return;
    }
    e.preventDefault();
    try { sessionStorage.setItem('mk-go', '1'); } catch (x) {}
    var href = a.href;
    if (reduce || !curtainEl || root.classList.contains('mk-design')) { location.href = href; return; }
    curtainEl.classList.add('is-on', 'is-leaving');
    setTimeout(function () { location.href = href; }, 220);
  });
  /* start loading the next page as soon as a finger or the mouse is on its link */
  var pre = {};
  function prefetch(e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a || !isPageLink(a) || a.pathname === location.pathname || pre[a.pathname]) return;
    pre[a.pathname] = 1; var l = d.createElement('link'); l.rel = 'prefetch'; l.href = a.href.split('#')[0]; d.head.appendChild(l);
  }
  d.addEventListener('pointerover', prefetch, { passive: true });
  d.addEventListener('touchstart', prefetch, { passive: true });

  /* The email is written backwards in the page and put together here, so spam bots reading the page never see it */
  var addr = '';
  function rv(x) { return (x || '').split('').reverse().join(''); }
  function buildMail() {
    var m = $('#footMail'); if (!m || !m.getAttribute('data-u')) return;
    addr = rv(m.getAttribute('data-u')) + String.fromCharCode(64) + rv(m.getAttribute('data-d'));
    m.textContent = addr; m.setAttribute('href', 'mai' + 'lto:' + addr);
  }
  buildMail();
  d.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-copy]') : null; if (!btn) return;
    var el = d.getElementById(btn.getAttribute('data-copy'));
    function done(l) { btn.textContent = l; setTimeout(function () { btn.textContent = 'Copy'; }, 1600); }
    function sel() { var r = d.createRange(); r.selectNodeContents(el); var s = w.getSelection(); s.removeAllRanges(); s.addRange(r); done('Selected'); }
    try { navigator.clipboard.writeText(addr).then(function () { done('Copied'); }, sel); } catch (x) { sel(); }
  });

  /* Arriving on the home page with a section in the link (from another page): land it under the menu */
  hashJump(); onScroll();
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { var id = (location.hash || '').slice(1); if (held && held === id) jump(id, false); onScroll(); });

  /* Theme editor: a changed section is drawn again, so fill in the parts the script adds */
  d.addEventListener('shopify:section:load', function () {
    buildMail();
    var wv = $('#wave');
    if (wv && !wv.children.length) wv.innerHTML = waveBars(desk.matches ? 64 : 40);
    var pl = $('#player'); if (pl) pl.classList.add('is-vis');
    layout();
  });
})();
